import Box from "@mui/material/Box";
import AddIcon from "@mui/icons-material/Add";
import { useTranslationApp } from "../../lib/i18next";
import { APPROVAL_ADD_REVIEWER } from "../../i18n/keysTranslations";

const ApprovalAddReviewerButton = ({ onClick = () => {}, sx = {} }) => {
  const { t } = useTranslationApp();

  return (
    <Box
      component="button"
      type="button"
      onClick={onClick}
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: 0.5,
        alignSelf: "flex-start",
        border: 0,
        bgcolor: "transparent",
        color: "text.secondary",
        cursor: "pointer",
        p: 0,
        fontSize: "0.875rem",
        fontWeight: 600,
        textDecoration: "underline",
        textUnderlineOffset: "3px",
        flexShrink: 0,
        ...sx,
      }}
    >
      <AddIcon sx={{ fontSize: 18 }} />
      {t(APPROVAL_ADD_REVIEWER)}
    </Box>
  );
};

export default ApprovalAddReviewerButton;
